import Vue from 'vue';
import useAcl from '@/@core/directives/acl/acl.directive';
import { aclChecker } from '@/data/utils/acl';

Vue.directive('acl', useAcl(aclChecker));

/**
 * Custom directive Cleave
 */

import Cleave from 'cleave.js';
import { DirectiveBinding } from 'vue/types/options';

const cleave = {
	name: 'cleave',
	bind(el: HTMLElement, binding: DirectiveBinding) {
		const input = el.querySelector('input');
		(input as any)._vCleave = new Cleave(input, binding.value);
	},
	unbind(el: HTMLElement) {
		const input = el.querySelector('input');
		(input as any)._vCleave.destroy();
	}
};

Vue.directive('cleave', cleave);
